import Breadcrumb from "app/containers/Features/components/Breadcrumb";
import { actions as memberActions } from "app/containers/Features/components/MemberSelection/redux/slice";
import { ticketGroupsActions } from "app/containers/Features/containers/Boards/containers/Tickets/redux/slice";
import { useUpdateFavorite } from "app/hooks/useUpdateFavorite";
import {
  selectBoardMenuData,
  selectIsCollapseSidebarMenu,
  selectProjectSettingDetails,
} from "app/redux/selector";
import { BoardType } from "app/types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { FavoriteTypeEnum } from "../types";
import BoardMenu from "./BoardMenu";
import CreateTaskButton from "./CreateTaskButton";
import FilterBar from "./FilterBar/index";
import FilterButton from "./FilterButton";
import { actions as boardSettingActions } from "./Settings/redux/slice";
import SettingsButton from "./Settings/SettingsButton";
import StartButton from "./StarButton";
import { useBoardsActions } from "./useBoardsActions";
import { projectComponentSaga } from "../../TeamSettings/container/Projects/container/ProjectComponent/redux/saga";
import {
  componentReducer,
  componentSliceKey,
} from "../../TeamSettings/container/Projects/container/ProjectComponent/redux/slice";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";
import clsx from "clsx";

export default function Layout({ children }: { children: React.ReactNode }) {
  useInjectReducer({
    key: componentSliceKey,
    reducer: componentReducer,
  });
  useInjectSaga({
    key: componentSliceKey,
    saga: projectComponentSaga,
  });
  const location = useLocation();
  const pathname = location.pathname;
  const dispatch = useDispatch();
  const params = useParams();
  const selectedProject = useSelector(selectProjectSettingDetails);
  const [filter, setFilter] = useState(false);
  const boardData = useSelector(selectBoardMenuData);
  const isSidebarOpen = useSelector(selectIsCollapseSidebarMenu);
  const {
    fetchBoardDetails,
    fetchBoardsMenus,
    fetchProjectSettings,
    fetchBoardsGroupsJson,
  } = useBoardsActions(params?.project as string);

  useEffect(() => {
    if (params?.team && params.project) {
      fetchProjectSettings(params.project);
    }
    return () => {};
  }, [params]);

  const { updateFavorite } = useUpdateFavorite();

  const handleFavoriteBoard = () => {
    if (params.boardId) {
      updateFavorite(params.boardId as string, FavoriteTypeEnum.BOARD);
    }
  };

  useEffect(() => {
    if (selectedProject?._id !== params?.project) {
      fetchBoardsMenus();
    }
  }, [selectedProject, params?.project]);

  useEffect(() => {
    dispatch(boardSettingActions.setBoardLoading(true));
    dispatch(ticketGroupsActions.setGroupingLoader(true));
    if (params.boardId && selectedProject?._id === params?.project) {
      fetchBoardDetails(params.boardId, (groupBy, subGroupBy) => {
        setTimeout(() => {
          fetchBoardsGroupsJson(params.boardId as string, groupBy, subGroupBy);
        }, 2000);
      });
    }

    return () => {};
  }, [params.boardId, selectedProject?._id]);

  useEffect(() => {
    if (params?.project as string) {
      dispatch(
        memberActions.fetchProjectMembersList({
          id: params?.project as string,
          callback() {},
        }),
      );
    }

    return () => {};
  }, [params?.project]);
  const currentBoard = boardData.find((x) => x.boardId === params.boardId);
  const isBacklogBoard = currentBoard?.Type === BoardType.Backlog;

  return (
    <div className="flex flex-col gap-3 relative">
      <Breadcrumb />

      {/* Responsive Board Navigation Container */}
      <div
        // className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-3 px-[24px]"
        className={clsx(
          "flex flex-col lg:flex-row justify-between items-start lg:items-center gap-3 px-[24px]",
          isSidebarOpen
            ? "max-w-[calc(100vw-248px)]"
            : "max-w-[calc(100vw-48px)]",
        )}
      >
        {/* Board Menu Section - Takes available width */}
        <div className="flex flex-row gap-[6px] items-center flex-wrap w-full lg:flex-1 min-w-0">
          <div className="flex-1 min-w-0">
            <BoardMenu />
          </div>
        </div>

        {/* Action Buttons - Always visible on larger screens */}
        {!pathname.endsWith("/boards") && (
          <div className="flex flex-row gap-[16px] items-center flex-shrink-0 w-full lg:w-auto justify-end">
            {!isBacklogBoard && (
              <StartButton
                onClick={handleFavoriteBoard}
                isFavorite={currentBoard?.favorite === 1}
              />
            )}
            <SettingsButton />
            <FilterButton filter={filter} setFilter={setFilter} />
            <CreateTaskButton />
          </div>
        )}
      </div>

      {filter && <FilterBar />}
      <div className="w-full min-w-0 overflow-auto relative">{children}</div>
    </div>
  );
}
